//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import WordAreaView from "@/components/objects/WordAreaView.vue";
import { v4 as uuidv4 } from 'uuid';

export default {
  name: "Images",
  components: { WordAreaView },
  inject: {
    specialProject: {
      default: false
    }
  },
  provide () {
    return {
      source: this.sourceProp
    }
  },
  props: {
    images: {
      type: Array
    },
    label: {
      type: String
    },
    user: {
      type: Object,
      default: () => {}
    },
    fetchImagePath: {
      type: String
    },
    sourceProp: {
      type: String,
      default: 'objIllustration'
    },
  },
  data() {
    return {
      swiper: undefined,
      uuid: '',
      templateValue: null
    }
  },
  computed: {
    currentSlideIndex() {
      return this.swiper?.activeIndex ?? 0
    },
    currentCanvasId() {
      return `canvas-${this.listInfo.id}${this.currentSlideIndex}`
    },
    humanReadableSourceCopyright() {
      const currentImage = this.images?.[this.currentSlideIndex]
      try {
        if (currentImage?.image_url) {
          return `${new URL(currentImage.image_url).origin}`
        }
      } catch {
      }

      return ''
    },
    listInfo() {
      return {
        subLabel: this.images.sublabel || "",
        icon: this.images.icon,
        vistat_object: this.images.vistat_object,
        object_label: this.label,
        id: uuidv4(),
      }
    }
  },
  watch: {
    images: {
      handler() {
        this.init()
      },
      deep: true
    },
  },
  mounted() {
    this.uuid = uuidv4()
    // eslint-disable-next-line nuxt/no-env-in-hooks
    if (process.client) {
      if (this.images.length) this.init()
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandled, { passive: true })
  },
  methods: {
    createCurrentScreenShot(payload) {
      const currentView = this.$refs.workAreaViews?.[this.currentSlideIndex]
      if (currentView?.createScreenShot) {
        return currentView.createScreenShot(payload)
      }
      return Promise.resolve()
    },
    onTemplateChange(evt) {
      this.templateValue = evt
      if (this.swiper) {
        setTimeout(() => {
          this.swiper.updateAutoHeight()
        }, 500)
      }
    },
    resizeHandled() {
      this.swiper.updateAutoHeight(0)
      this.swiper.update()
    },
    workAreaReady() {
      this.swiper.updateAutoHeight(0)
    },
    init() {
      const initWorkArea = (index = 0) => {
        this.$refs.workAreaViews[index].create(this.$refs.workAreaViews[index].$el.offsetWidth)
      }
      import('@/plugins/swiper.js')
        .then(({ Swiper, Navigation, Pagination }) => {
          this.swiper = new Swiper(this.$refs.slider, {
            autoHeight: true,
            preventClicks: false,
            preventClicksPropagation: false,
            touchStartPreventDefault: false,
            threshold: 50,
            pagination: {
              enabled: this.images.length > 1,
              el: `.pagination-${this.uuid}`,
              clickable: true,
              dynamicBullets: true
            },
            navigation: {
              nextEl: `.next-${this.uuid}`,
              prevEl: `.prev-${this.uuid}`,
            },
            init: false,
            modules: [Navigation, Pagination],
            on: {
              activeIndexChange: () => {
                initWorkArea(this.swiper.activeIndex)
              },
              init() {
                initWorkArea(0)
              }
            }
          });

          this.swiper.init()

          window.addEventListener('resize', this.resizeHandled, { passive: true })
        })
    }
  }
}
